import { Link } from "react-router-dom";
import { SiteHeader } from "../../components/site/SiteHeader";
import { NetworkCanvas } from "../../components/NetworkCanvas";
import { MaskedLine, FadeIn } from "../../components/motion/Reveal";

export default function NotFound() {
  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased min-h-screen flex flex-col" data-testid="not-found-page">
      <SiteHeader />
      <section className="relative flex-1 flex items-center overflow-hidden pt-24">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,#10203a_0%,#0a1526_60%,#060d1a_100%)]" />
        <NetworkCanvas skyline={false} className="absolute inset-0 w-full h-full opacity-40" />
        <div className="relative nx-wrap">
          <h1 className="font-marcellus text-7xl sm:text-8xl lg:text-9xl nx-text-outline" data-testid="not-found-code">
            <MaskedLine delay={0.2}>404</MaskedLine>
          </h1>
          <h2 className="font-marcellus text-2xl sm:text-3xl text-white mt-4">
            <MaskedLine delay={0.4}>Looks like this connection was interrupted.</MaskedLine>
          </h2>
          <FadeIn delay={0.7}>
            <p className="mt-5 text-base text-slate-400 max-w-md leading-relaxed">The page you're looking for doesn't exist or has moved. Let's get you back to solid infrastructure.</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link to="/" data-testid="not-found-home-link" className="inline-block bg-nx-gold hover:bg-nx-goldlight text-nx-navy font-semibold text-sm tracking-wide px-8 py-4 transition-all duration-300 hover:-translate-y-0.5">
                Return Home
              </Link>
              <Link to="/solutions" data-testid="not-found-solutions-link" className="inline-block border border-white/25 hover:border-nx-goldlight/70 text-white text-sm tracking-wide px-8 py-4 transition-colors">
                Explore Solutions
              </Link>
              <Link to="/contact" data-testid="not-found-contact-link" className="inline-block border border-white/25 hover:border-nx-goldlight/70 text-white text-sm tracking-wide px-8 py-4 transition-colors">
                Contact NexSecure
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
